import Joi from '@hapi/joi'

export const FactorySchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    
}